import { ParsedRow } from "helpers/template-builder/types";
import { useTheme } from "injectors/theme";
import { FC } from "react";
import ObjectDetailsRow from "../object-details-row";
import { useStyles } from "./styles";

type Props = {
  label: string;
  rows: ParsedRow[];
  description?: string;
};

const ObjectDetailsCategory: FC<Props> = ({ label, rows, description }) => {
  const theme = useTheme();
  const styles = useStyles({ theme });

  return (
    <div className={styles.detailsCategoryWrapper}>
      <h3 className={styles.detailsCategoryTitle}>{label}</h3>

      {!!description && (
        <p className={styles.detailsCategoryDescription}>{description}</p>
      )}

      <div className={styles.detailsCategoryRowsWrapper}>
        {rows.map((rowData, index) => (
          <ObjectDetailsRow rowData={rowData} key={index} />
        ))}
      </div>
    </div>
  );
};

export { ObjectDetailsCategory };
